import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { MAP_HEIGHT } from '@bingads-webui-campaign/recommendation-core';

export class BingMapView extends React.PureComponent {
  static propTypes = {
    data: PropTypes.objectOf(PropTypes.any).isRequired,
    locationMap: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const MapView = props.locationMap;
    this.mapView = new MapView({
      disableInfoBoxGroupList: [],
      disableActionGroupList: ['recommended', 'included', 'excluded'],
      mapHeight: MAP_HEIGHT,
    });
    this.refreshData();
  }

  refreshData = () => {
    const {
      data,
    } = this.props;

    this.mapView.render();
    _.each(data.included, (includedPoint) => {
      this.mapView.addRadiusTargetToMap(includedPoint, 'included');
    });
    _.each(data.excluded, (excludedPoint) => {
      this.mapView.addRadiusTargetToMap(excludedPoint, 'excluded');
    });
    this.mapView.updateRecommendedLocations(data.recommended);
  }

  render() {
    return (
      <div className="bingmap-view">
        {<BackboneInstanceWrapper
          instance={this.mapView}
        /> }
      </div>
    );
  }
}
